const mockNotes = [
  {
    id: 1,
    title: 'Sagittis nam',
    description:
      'porttitor pede justo eu massa donec dapibus duis at velit eu proin at turpis a pede posuere nonummy integer non velit donec diam neque vestibulum eget vulputate ut ultrices id justo sit amet sapien dignissim vestibulum vestibulum ante ipsum primis in faucibus orci luctus duis at velit eu proin at turpis a pede posuere',
    category: 'Work',
    completed: true,
    date: '2020-12-07T12:39:57Z'
  },
  {
    id: 2,
    title: 'Ornare consequat lectus in',
    description:
      'luctus ultricies eu nibh quisque id justo sit amet sapien dignissim',
    category: 'Home',
    completed: false,
    date: '2020-08-02T11:45:43Z'
  },
  {
    id: 3,
    title: 'Integer ac neque',
    description:
      'dapibus augue vel accumsan tellus nisi eu orci mauris lacinia sapien quis libero nullam sit',
    category: 'Personal',
    completed: true,
    date: '2020-07-26T09:27:58Z'
  },
  {
    id: 4,
    title: 'In purus eu magna',
    description:
      'proin at turpis a pede posuere nonummy integer non velit donec diam neque vestibulum eget vulputate ut ultrices',
    category: 'Work',
    completed: false,
    date: '2020-12-29T21:35:29Z'
  },
  {
    id: 5,
    title: 'Neque aenean auctor gravida',
    description:
      'id justo sit amet sapien dignissim vestibulum vestibulum ante ipsum primis in faucibus orci luctus',
    category: 'Personal',
    completed: true,
    date: '2020-05-09T07:14:59Z'
  },
  {
    id: 6,
    title: 'Justo in blandit',
    description:
      'bibendum felis sed interdum venenatis turpis enim blandit mi in porttitor pede justo eu massa',
    category: 'Home',
    completed: false,
    date: '2020-06-03T04:44:00Z'
  },
  {
    id: 7,
    title: 'Libero rutrum',
    description:
      'scelerisque quam turpis adipiscing lorem vitae mattis nibh ligula nec sem duis aliquam convallis',
    category: 'Home',
    completed: false,
    date: '2020-12-25T09:40:01Z'
  },
  {
    id: 8,
    title: 'Turpis a',
    description:
      'curabitur in libero ut massa volutpat convallis morbi odio odio elementum eu interdum eu tincidunt in leo maecenas pulvinar',
    category: 'Home',
    completed: false,
    date: '2020-09-22T13:12:17Z'
  },
  {
    id: 9,
    title: 'Ipsum primis',
    description:
      'consequat ut nulla sed accumsan felis ut at dolor quis odio consequat varius integer',
    category: 'Personal',
    completed: false,
    date: '2020-06-19T01:47:51Z'
  },
  {
    id: 10,
    title: 'Sagittis nam',
    description:
      'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor',
    category: 'Personal',
    completed: false,
    date: '2021-01-27T05:46:34Z'
  }
]

export default mockNotes
